import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router";
import { toast } from "sonner";
import { useCurrentUser } from "@/features/login/hooks/useCurrentUser";
import { axiosInstance } from "@retro-ia/shared/axios";

export const useLogout = () => {
  const navigate = useNavigate();
  const { logout: clearUser } = useCurrentUser();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => {
      await axiosInstance.post("/auth/logout", {}, { withCredentials: true });
    },
    onSuccess: () => {
      queryClient.clear();
      clearUser();
      toast.success("Has cerrado sesión correctamente.");
      navigate("/");
    },
    onError: () => {
      toast.error("Error al cerrar sesión");
    },
  });
};
